import { addSplitText } from '../../utils/monitorUtil';

export const monitorSelectDefaultNoSelectedConfig: {
  [key: string]: Array<string>;
} = {
  e76337e746e1f95fdbf7e23c26010e448: [].map(item =>
    addSplitText(item, 'discord'),
  ),
};

export const filterSomeOptions = (gameId?: string) => {
  if (!gameId) {
    return [];
  }
  return monitorSelectDefaultNoSelectedConfig[gameId];
};

export enum SPECIAL_ACCOUNT_KEY {
  KEYWORD = 'keyword-search',
  PRIVATE = 'private-channels',
  EXTERNAL = 'external-data-sources',
  DEFAULT = 'default-account-group',
}

type AccountKeyListType = {
  key: string;
  isKeyword?: boolean;
  isPrivate?: boolean;
  isExternal?: boolean;
  textInfo: {
    text: string;
    textCN: string;
  };
};

export const accountKeyTitleList: AccountKeyListType[] = [
  {
    key: SPECIAL_ACCOUNT_KEY.KEYWORD,
    isKeyword: true,
    textInfo: {
      text: 'Keyword Search',
      textCN: '关键词搜索',
    },
  },
  {
    key: SPECIAL_ACCOUNT_KEY.DEFAULT,
    textInfo: { text: 'by Account', textCN: '官号' },
  },
  {
    key: 'official-accounts',
    textInfo: { text: 'Official Accounts', textCN: '官方运营账号' },
  },
  {
    key: 'discussion-groups',
    textInfo: {
      text: 'Discussion Groups/Forums',
      textCN: '讨论群组/论坛',
    },
  },
  {
    key: 'kol-monitoring',
    textInfo: { text: 'KOL Monitoring', textCN: '监控KOL' },
  },
  {
    key: 'single-post-comments',
    textInfo: {
      text: 'Single Post Comments/Barrages',
      textCN: '单帖评论/弹幕',
    },
  },
  {
    key: SPECIAL_ACCOUNT_KEY.PRIVATE,
    isPrivate: true,
    textInfo: {
      text: 'Private Channels',
      textCN: '私密渠道',
    },
  },
  {
    key: 'live-broadcast',
    textInfo: { text: 'Live Broadcast', textCN: '直播采集' },
  },
  {
    key: 'material',
    textInfo: { text: 'Material', textCN: 'UA素材' },
  },
  {
    key: SPECIAL_ACCOUNT_KEY.EXTERNAL,
    isExternal: true,
    textInfo: { text: 'External Data Sources', textCN: '外部数据源' },
  },
  {
    key: 'background-music',
    textInfo: {
      text: 'Background Music',
      textCN: '背景音乐',
    },
  },
];
